// import { labels } from '../../2-organisms/search/config';

const detailTemplate = data => {
  const template = `
<article class="map__detail-article">
  <header class="map__detail-header">
    ${
      data.image
        ? `<figure class="map__detail-figure">
        <picture class="picture picture--aspect-ratio-16-9">
          <img src="${data.image.src}" data-src="${
            data.image.src
          }" loading="lazy" alt="${data.image.alt}"/>
        </picture>
        ${
          data.image.copyright
            ? `<figcaption class="map__detail-caption caption caption--external-link">
            <div class="caption__content">${data.image.copyright}
                 ${
                   data.image.licenseUrl
                     ? `<a
                      class="styled-link styled-link--external "
                      href=${data.image.licenseUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span class=" icon icon--extern">
                        <svg class="icon__svg" role="img" aria-hidden="true">
                          <use href="#icon-extern" />
                        </svg>

                        <span class="sr-only">Externer Link</span>
                      </span>

                      <span class="styled-link__text">
                        ${data.image.licenseTitle || 'CC-BY-SA 2.0'}
                      </span>
                    </a>
                `
                     : ''
                 }
            </div>
            <button
              class="caption__button-copyright styled-button"
              type="button"
              aria-expanded="false"
            >
              <span class="icon icon--copyright">
                <svg class="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-copyright" />
                </svg>
                <span class="sr-only">Urheberrecht</span>
              </span>
              <span class="icon icon--close">
                <svg class="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-close" />
                </svg>
                <span class="sr-only">schließen</span>
              </span>
            </button>
          </figcaption>`
            : ''
        }
      </figure>`
        : ''
    }
    ${
      data.mark
        ? `<div class="map__detail-info">
          <div class="map__detail-meta">
          <div class="map__detail-type">${
            Array.isArray(data.mark)
              ? data.mark.join(
                  '<span class="map__detail-type-separator" aria-hidden="true">|</span>'
                )
              : data.mark
          }</div>
        </div>
      </div>`
        : ''
    }
    ${data.title ? `<h2 class="map__detail-heading">${data.title}</h2>` : ''}
  </header>

  ${
    data.teaser
      ? `<p class="map__detail-teaser">
        ${data.teaser}
    </p>`
      : ''
  }

  <footer class="map__detail-footer">
  ${
    data.url
      ? `<a class="styled-link styled-link--icon styled-link--map" href="${data.url}">
    <span class="styled-link__icon icon icon--arrow-right--bold">
      <svg class="icon__svg" role="img" aria-hidden="true">
        <use href="#icon-arrow-right--bold"></use>
      </svg>
    </span>
    <span class="styled-link__text">
      ${data.title}
    </span>
  </a>`
      : ''
  }
  ${
    data.website
      ? `<a class="styled-link styled-link--icon styled-link--map" href="${data.website}"
     target="_blank">
     <span class="styled-link__icon icon icon--extern">
          <svg class="icon__svg" role="img" aria-hidden="true">
            <use href="#icon-extern"></use>
          </svg>
        </span>
        <span class="styled-link__text">Zur Homepage</span>
    </a>`
      : ''
  }
  </footer>
</article>`;
  return template;
};

export { detailTemplate };
